
import { defineComponent } from 'vue'
import Button from '@/components/Button.vue'
import Box from '@/components/Box.vue'
import LinkArrow from '@/components/LinkArrow.vue'
import Selectel from '@/components/Selectel.vue'
import Share from '@/components/Share.vue'
import LinkIcon from '@/components/LinkIcon.vue'

export default defineComponent({
  name: 'Home',
  components: {
    'tp-box': Box,
    'tp-button': Button,
    'tp-link-arrow': LinkArrow,
    'tp-share': Share,
    'tp-link-icon': LinkIcon,
    selectel: Selectel,
  },
  data: function () {
    return {
      targetTitle: '',
      isConf: ''
    }
  },
  methods: {
    restart() {
      this.$store.dispatch('setGameStatus', true)
      this.$router.push('/game')
    },
  },
  mounted() {
    if (this.$store.getters.isLose === false) {
      this.$router.push('/')
    }

    //@ts-ignore
    if (window.game2048) {
      //@ts-ignore
      if (window.game2048.conf && window.game2048.conf !== '') {
        //@ts-ignore
        this.isConf = window.game2048.conf
      }
    }

    //@ts-ignore
    if (window.ta) {
      //@ts-ignore
      ta('specials.2048.noMoreMoves', 1)
    }

    this.$store.dispatch('setLoseStatus', false)
    this.$store.dispatch('setWinStatus', false)
    const target = this.$store.getters.target || null
    if (target) {
      this.targetTitle = target.title || ''
    }
  },
})
